/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type MeasurementUnit = "CM" | "IN" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedMeasurementUnitProvider_user$ref: FragmentReference;
export type SbSharedMeasurementUnitProvider_user = {|
  +profile: ?{|
    +measurementUnit: ?MeasurementUnit
  |},
  +$refType: SbSharedMeasurementUnitProvider_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedMeasurementUnitProvider_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "measurementUnit",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5c2bb3a900c1e1289a6ed19186e53895';
module.exports = node;
